"use client";

import { usePathname } from "next/navigation";
import { Link } from "~/i18n/routing";
import styles from "./ErrorPage.module.css";

export type ErrorProps = {
	error: Error & {
		digest: string;
	};
	reset: () => void;
};

export const ErrorPage = ({ error, reset }: ErrorProps) => {
	const pathname = usePathname();
	const isHome = pathname === "/";

	const forceReset = () => {
		// Perform a full storage clear and reload
		localStorage.clear();
		sessionStorage.clear();
		window.location.reload();
	};

	return (
		<main data-layout="page" className={styles.errorPage}>
			<h2 className={styles.title}>En feil har oppstått</h2>
			<p>Vi har logget feilen og jobber med å løse problemet. Prøv igjen om litt.</p>
			{error.digest && (
				<pre>
					<code>Digest: {error.digest}</code>
				</pre>
			)}

			<div className={styles.buttons}>
				<button onClick={forceReset} type="button" className="medium">
					Prøv på nytt
				</button>
				{!isHome && (
					<Link shallow={false} prefetch={false} href="/" type="button" className="transparent">
						Gå til forsiden
					</Link>
				)}
			</div>

			{process.env.NODE_ENV === "development" && <DeveloperError error={error} />}
		</main>
	);
};

const DeveloperError = ({ error }: { error: ErrorProps["error"] }) => {
	return (
		<div className={styles.devError}>
			<h4>DevMode only error: {error.message}</h4>
			<p>Stack trace:</p>
			<pre className={styles.pre}>{error.stack}</pre>

			<p>Details:</p>
			<pre className={styles.pre}>
				<code>
					{JSON.stringify(
						{
							name: error.name,
							message: error.message,
							digest: error.digest,
							cause: error.cause,
						},
						null,
						2,
					)}
				</code>
			</pre>
		</div>
	);
};
